import React, { useState } from "react";
import "./Manual.scss";
import { faro } from "@grafana/faro-react";
import { Button } from "@pav/pav-products-design-system";
import ManualEntryModal from "./ManualEntryModal/ManualEntryModal";
import ManualEntryForm from "./ManualEntryModal/ManualEntryForm";
import { Box, useMediaQuery, useTheme } from "@mui/material";

export default function Manual({
  onDataChanged,
  plaidDefault,
  enrollmentStep,
}) {
  const [show, setShow] = useState(false);
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("md"));

  const handleClose = () => {
    faro.api.pushEvent("Cancelled Manual Bank Add");
    setShow(false);
  };

  const handleShow = () => {
    faro.api.pushEvent("Enrollment - User selected manual bank entry button");
    setShow(true);
  };

  return (
    <>
      {(!plaidDefault || !enrollmentStep) && (
        <Box
          sx={{
            display: "flex",
            alignItems: isMobile ? "center" : "flex-start",
            margin: "10px 0 32px 0",
            width: "100%",
          }}
        >
          <Button
            buttonType="secondary"
            onClick={handleShow}
            fullWidth
            padding="var(--spacing-md) var(--spacing-lg)"
          >
            Manually Enter Bank Info
          </Button>
        </Box>
      )}
      {plaidDefault && enrollmentStep && (
        <Box
          sx={{
            display: "flex",
            alignItems: isMobile ? "center" : "flex-start",
            margin: "10px 0 32px 0",
            width: "100%",
          }}
        >
          <Button
            buttonType="secondary"
            onClick={handleShow}
            fullWidth
            padding="var(--spacing-md) var(--spacing-lg)"
          >
            Manually Enter Bank Info
          </Button>
        </Box>
      )}
      <ManualEntryModal open={show}>
        <ManualEntryForm
          handleClose={handleClose}
          onDataChanged={onDataChanged}
        />
      </ManualEntryModal>
    </>
  );
}
